// queries/utilityFootprintQueries.ts
import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";

import { UtilityFootprint } from "../../../domain/utilities/UtilityFootprint";


const ECSQL_UTILITY_FOOTPRINT_BY_ELEMENT = `
  SELECT
    b.NodeLength AS NodeLengthM,
    b.NodeWidth  AS NodeWidthM
  FROM CifSubsurfaceConflictAnalysis.BaseNode_PhysicalAspect b
  WHERE b.Element.Id = ?
`;

/**
 * Reads the Utility Footprint (length/width) for a node element.
 * NodeLength / NodeWidth are stored in meters; this helper also
 * computes feet for convenience.
 */
export async function queryUtilityFootprintForElement(
  iModel: IModelConnection,
  elementId: string,
): Promise<UtilityFootprint | undefined> {
  const reader = iModel.createQueryReader(
    ECSQL_UTILITY_FOOTPRINT_BY_ELEMENT,
    QueryBinder.from([elementId]),
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any;

    const lengthM = typeof plain.NodeLengthM === "number" ? plain.NodeLengthM : 0;
    const widthM  = typeof plain.NodeWidthM  === "number" ? plain.NodeWidthM  : 0;

    return new UtilityFootprint({
      LengthMeters: lengthM,
      WidthMeters: widthM,
    });
  }

  // No BaseNode_PhysicalAspect on that element (unlikely for your LTP, but safe)
  return undefined;
}

